import { Container } from '@socialchorus/shared-ui-components';
import { LoadingSkeleton } from '../../../loading-skeleton';
import styles from './enterprise-loading-skeleton-image.module.scss';
import { Fragment } from 'react';
export function EnterpriseLoadingSkeletonImage() {
  const numOfCards = 8;
  const childComponents = [];

  const loadingCardComponent = (
    <Container className={styles.EnterpriseSearchItem} shape="small">
      <section className={styles.ItemImage}>
        <LoadingSkeleton height={150} borderRadius={0} marginTop={0} />
      </section>

      <section className={styles.ItemTitle}>
        <LoadingSkeleton />
        <LoadingSkeleton />
        <LoadingSkeleton />
        <LoadingSkeleton />
      </section>
      <section className={styles.ItemAuthor}>
        <LoadingSkeleton height={10} width={'50%'} marginTop={15} />
      </section>
    </Container>
  );

  for (let i = 0; i < numOfCards; i++) {
    childComponents.push(<Fragment key={i}>{loadingCardComponent}</Fragment>);
  }
  return <div className={styles.SearchResultRow}>{childComponents}</div>;
}
